import { useCallback } from 'react'
import dayjs from 'dayjs'
import { RotaOverviewFilters } from 'screens/Rostering/hooks/useRotaOverview'
import { postJSON } from 'common/services/api'
import { YEAR_FIRST_DATE_FORMAT } from 'screens/Rostering/utils.datetime'
import useMixpanelEvent, { MixpanelEvents } from 'hooks/useMixpanelEvent'

function mapFiltersToApi(filters: RotaOverviewFilters) {
  const mapped: Record<string, any> = {}

  if (filters.from) {
    mapped.from = dayjs(filters.from).format(YEAR_FIRST_DATE_FORMAT)
  }
  if (filters.to) {
    mapped.to = dayjs(filters.to).format(YEAR_FIRST_DATE_FORMAT)
  }
  if (filters.teamMembers) {
    mapped.teamMembers = filters.teamMembers
  }
  if (filters.contractTypes) {
    mapped.contractTypes = filters.contractTypes
  }

  return mapped
}

export function useExportRotaOverviewCsv(filters: RotaOverviewFilters) {
  const sendEvent = useMixpanelEvent()

  return useCallback(async () => {
    try {
      const mappedFilters = mapFiltersToApi(filters)
      const url = '/rota-reporting/export-overview'

      const result = await postJSON({
        url,
        method: 'POST',
        isRota: true,
        responseType: 'arrayBuffer',
        body: JSON.stringify(mappedFilters),
      })
      if (!result) {
        alert('No data received from server')
        return
      }

      sendEvent(MixpanelEvents.ROSTERING_REPORT_DOWNLOADED, {
        reportType: 'overview',
        daysCovered: dayjs(filters.to).diff(dayjs(filters.from), 'day') + 1,
      })

      const blob = new Blob([result], { type: 'text/csv' })
      const filename = 'rota-overview.csv'
      const blobUrl = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = blobUrl
      a.download = filename
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(blobUrl)
    } catch (err) {
      console.error(err)
      alert('Failed to export CSV')
    }
  }, [filters])
}
